const devices = [
  { key: 0, value: 'Desktop', text: 'Desktop' },
  { key: 1, value: 'Mobile', text: 'Mobile' }
];

export default devices;



// WEBPACK FOOTER //
// ./src/components/common/Devices.js